var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_vm._v(" "+_vm._s(_vm.params.cleaned_start_date)+" to "+_vm._s(_vm.params.cleaned_end_date)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }